import React, { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Tab, Tabs } from '@mui/material';
import SidebarLayout from '../../layouts/SidebarLayout';
import { preparationActions } from '../../store/MedicalRecord/preparation';
import { backgroundDataActions } from '../../store/MedicalRecord/backgroundData';
import { consultationReasonsActions } from '../../store/MedicalRecord/consultationReasons';
import { currentProblemActions } from '../../store/MedicalRecord/currentProblem';
import { physicalExamActions } from '../../store/MedicalRecord/physicalExamn';
import { organSystemReviewActions } from '../../store/MedicalRecord/organSystemReview';
import { diagnosticActions } from '../../store/MedicalRecord/diagnostic';
import { treatmentActions } from '../../store/MedicalRecord/treatment';
import { Roles } from '../../../utils/roles';
import { Patient } from '../../../domain/entities';
import { useUserService } from '../../hooks';
import MedicalRecord from './components/MedicalRecord/MedicalRecord';
import PatientGeneralData from '../Patients/components/PatientGeneralData/PatientGeneralData';
import MedicalHistory from './components/MedicalHistory/MedicalHistory';

const patientData: Patient = {
  id: '1',
  name: 'Xavier García',
  ssn: '0912345678',
  birthDate: new Date('1997-12-19'),
  gender: 'M',
  civilStatus: 'Soltero',
  address: 'Sauces 6 Mz 125 Villa 41',
  state: 'Guayas',
  city: 'Guayaquil',
  phone: '2147583',
  cellphone: '0913784698',
  email: 'xavier.garcia@test.com'
};

interface TabPanelProps {
  children: ReactNode;
  value: number;
  index: number;
  other?: any;
}

const TabPanel = ({ children, value, index, ...other }: TabPanelProps) => {
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`medical-tabpanel-${index}`}
      aria-labelledby={`medical-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

function a11yProps(index: number) {
  return {
    id: `medical-tab-${index}`,
    'aria-controls': `medical-tabpanel-${index}`
  };
}

function OnlyDoctorTab({ ...props }) {
  const UserService = useUserService();

  if (UserService.hasRole(Roles.doctor)) {
    return <Tab {...props} />;
  }
  return <div />;
}

const MedicalAppointment = () => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState<number>(0);

  const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(preparationActions.reset());
    dispatch(backgroundDataActions.reset());
    dispatch(consultationReasonsActions.reset());
    dispatch(currentProblemActions.reset());
    dispatch(physicalExamActions.reset());
    dispatch(organSystemReviewActions.reset());
    dispatch(diagnosticActions.reset());
    dispatch(treatmentActions.reset());
  }, []);

  return (
    <SidebarLayout>
      <Box sx={{ width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            borderBottom: 1,
            borderColor: 'divider',
            width: '100%'
          }}
        >
          <Tabs
            value={value}
            variant='scrollable'
            scrollButtons='auto'
            onChange={handleChange}
            aria-label='tabs'
          >
            <Tab label='Consulta' {...a11yProps(0)} />
            <Tab label='Paciente' {...a11yProps(1)} />
            <OnlyDoctorTab label='Historial Médico' {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <MedicalRecord viewMode={false} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <PatientGeneralData
            patient={patientData}
            style={{ margin: 'auto', maxWidth: '1024px', marginTop: '24px' }}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <MedicalHistory patient={patientData} />
        </TabPanel>
      </Box>
    </SidebarLayout>
  );
};

export default MedicalAppointment;
